import { Action } from 'redux';
import { Employee } from 'src/types/model';

export interface ItemCategoryState {
  loading: boolean;
  data: Employee[];
  error: string | null;
}

export const FETCH_EMPLOYEE_REQUEST = 'FETCH_EMPLOYEE_REQUEST';
export const FETCH_EMPLOYEE_SUCCESS = 'FETCH_EMPLOYEE_SUCCESS';
export const FETCH_EMPLOYEE_FAILURE = 'FETCH_EMPLOYEE_FAILURE';

export interface FetchEmployeeRequestAction
  extends Action<typeof FETCH_EMPLOYEE_REQUEST> {}

export interface FetchEmployeeSuccessAction
  extends Action<typeof FETCH_EMPLOYEE_SUCCESS> {
  payload: Employee[];
}

export interface FetchEmployeeFailureAction
  extends Action<typeof FETCH_EMPLOYEE_FAILURE> {
  payload: string;
}

export type EmployeeActionType =
  | FetchEmployeeRequestAction
  | FetchEmployeeSuccessAction
  | FetchEmployeeFailureAction;
